import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/**
 * SN 產品名稱對照 list query → API params。
 * Filter：`keyword`、`product_code`、`product_name`、`status`、`customer_id`、`remark`；
 * sort 白名單：`product_code`、`product_name`、`status`、`updated_at`。
 *
 * @param {object} listQuery
 */
export function snProductMappingListQueryToApiParams(listQuery = {}) {
  return listQueryToApiParams(joinMultiValueFilters({
    ...listQuery,
    keyword: String(listQuery.keyword ?? '').trim(),
  }));
}
